"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JitterFactory = void 0;
const full_jitter_1 = require("./full/full.jitter");
const no_jitter_1 = require("./no/no.jitter");
function JitterFactory(options) {
    switch (options.jitter) {
        case "full":
            return full_jitter_1.fullJitter;
        case "none":
        default:
            return no_jitter_1.noJitter;
    }
}
exports.JitterFactory = JitterFactory;
